// components/templates/sections/Header.tsx
'use client';
import Link from 'next/link';
import Image from 'next/image';
import { useDesign } from '@/context/DesignContext';

interface HeaderProps {
  logoUrl: string;
  navItems?: any[];
  phone?: string;
  design?: any; // optional prop override
}

export default function Header({ logoUrl, navItems = [], phone, design: propDesign }: HeaderProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;

  // Extract design values with fallbacks
  const navLinkColor = design?.colors?.text || '#1E1E1E';
  const navLinkHoverColor = design?.colors?.primary || '#E07A5F';
  const primaryButton = design?.buttons?.primary || {
    class: 'tf-button style1',
    backgroundColor: 'var(--primary)',
    textColor: '#FFFFFF',
    borderRadius: '30px',
    padding: '12px 30px'
  };
  const containerMaxWidth = design?.spacing?.containerMaxWidth || '1200px';

  // Inline style for navigation links
  const linkStyle = (hover = false) => ({
    color: hover ? navLinkHoverColor : navLinkColor,
    textDecoration: 'none',
    transition: design?.effects?.transition || 'all 0.3s ease',
  });

  // Button style
  const buttonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.4rem',
    padding: primaryButton.padding,
    borderRadius: primaryButton.borderRadius,
    backgroundColor: primaryButton.backgroundColor,
    color: primaryButton.textColor,
    border: primaryButton.borderColor ? `1px solid ${primaryButton.borderColor}` : 'none',
    cursor: 'pointer',
    transition: design?.effects?.transition || 'all 0.3s ease',
  };

  return (
    <header id="header_main" className="header style-1">
      <div className="container" style={{ maxWidth: containerMaxWidth, margin: '0 auto' }}>
        <div id="site-header-inner">
          <div className="header__logo">
            <Link href="/">
              <Image src={logoUrl} alt="logo" width={140} height={40} />
            </Link>
          </div>
          <nav id="main-nav" className="main-nav">
            <ul id="menu-primary-menu" className="menu" style={{ display: 'flex', gap: '1.5rem', listStyle: 'none' }}>
              {/* Simplified example – you can map navItems if needed */}
              <li className="menu-item menu-item-has-children current-menu-item">
                <a href="#" style={linkStyle()}>Home</a>
              </li>
              <li className="menu-item menu-item-has-children">
                <a href="#" style={linkStyle()}>Pages</a>
              </li>
              <li className="menu-item menu-item-has-children">
                <a href="#" style={linkStyle()}>Menu</a>
              </li>
              <li className="menu-item menu-item-has-children">
                <a href="#" style={linkStyle()}>Portfolio</a>
              </li>
              <li className="menu-item menu-item-has-children">
                <a href="#" style={linkStyle()}>Blog</a>
              </li>
              <li className="menu-item menu-item-has-children">
                <a href="#" style={linkStyle()}>Contact</a>
              </li>
            </ul>
          </nav>

          <Link href="/book" className={primaryButton.class} style={buttonStyle}>
            BOOK A TABLE
          </Link>

          {/* Sidebar and mobile button – keep original classes, but styles can be overridden by CSS variables */}
          <div className="sidebar-btn">
            <a className="btn-side"><span></span></a>
            <div className="sidebar-content">
              <Image src={logoUrl} alt="logo" width={140} height={40} />
              <p>Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
              <h4>+(406) 555-0120</h4>
              <p>Andé Restaurant 767 5th Avenue, Paris 10021, France</p>
              <p>Brochetterestaurant@gmail.com</p>
              <div className="line"></div>
              <p>Opening Hour: <br /> Mon - Fri : 9.00am - 22.00pm, Holidays : Close</p>
              <div className="line"></div>
              <ul className="list-social">
                <li><a href="#" style={linkStyle()}><i className="fa-brands fa-facebook-f"></i></a></li>
                <li><a href="#" style={linkStyle()}><i className="fa-brands fa-twitter"></i></a></li>
                <li><a href="#" style={linkStyle()}><i className="fa-solid fa-envelope"></i></a></li>
                <li><a href="#" style={linkStyle()}><i className="fa-brands fa-instagram"></i></a></li>
              </ul>
            </div>
          </div>
          <div className="mobile-button"><span></span></div>
        </div>
      </div>
    </header>
  );
}